import {
  faBuildingColumns,
  faCreditCard,
  faGift,
  faMoneyBill,
  faMoneyBillAlt,
  faMoneyCheck,
} from '@fortawesome/pro-regular-svg-icons';

import { PaymentMethodType } from './_types';

const SEPA_COUNTRIES = ['AU', 'AT', 'BE', 'BG', 'CA', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HK', 'HU', 'IE', 'IT', 'JP', 'LV', 'LT', 'LU', 'MT', 'MX', 'NL', 'NZ', 'NO', 'PL', 'PT', 'RO', 'SG', 'SK', 'SI', 'ES', 'SE', 'CH', 'GB', 'US'];

export const getPaymentMethodType = (type: string): string => {
  switch (type.toLowerCase()) {
    case 'card':
      return 'Credit Card';
    case 'us_bank_account':
      return 'Bank Account';
    default:
      return type;
  }
};

export const getPaymentMethodIcon = (type: string) => {
  switch (type.toLowerCase()) {
    case 'card':
      return faCreditCard;
    case 'us_bank_account':
      return faBuildingColumns;
    case 'cash':
      return faMoneyBill;
    case 'check':
      return faMoneyCheck;
    case 'free':
      return faGift;
    case 'other':
      return faMoneyBillAlt;
    default:
      return faCreditCard;
  }
};

export const getPaymentMethodsForCurrency = (
  currency: string,
  platformCountry: string
): PaymentMethodType[] => {
  if (currency === 'usd' && platformCountry === 'US') {
    return ['card', 'us_bank_account'];
  } else if (currency === 'gbp' && platformCountry === 'GB') {
    return ['card'];
  } else if (currency === 'cad' && platformCountry === 'CA') {
    return ['card', 'acss_debit'];
  } else if (currency === 'eur' && SEPA_COUNTRIES.includes(platformCountry)) {
    return ['card', 'sepa_debit'];
  } else if (currency === 'aud' && platformCountry === 'AU') {
    return ['card', 'au_becs_debit'];
  }
  return ['card'];
};
